/**
 * @ngdoc controllers
 * @memberof mercury.directives.breakdetails
 * @name BreakDetailsCtrl
 */
angular.module('mercury.directives.breakdetails')
.controller('BreakDetailsCtrl', ["dialog", "$scope", "dialogData", "shiftHelpers", function(dialog, $scope, dialogData, shiftHelpers) {

  $scope.clock = dialogData.clock;

  $scope.clock.breaks.forEach(function(breakObj) {
    breakObj.duration = shiftHelpers.calculateBreakDuration(breakObj.breakStart, breakObj.breakEnd);
  });

  $scope.cancel = function() {
    dialog.close({});
  };
}]);
